import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import {removeAuthUseList, toggleDropBox, addList, isSavedList} from '../../actions'
import {TOGGLE_LISTS_SUCCESS, TOGGLE_SETTING_SUCCESS} from '../../actionTypes'
import { Link } from 'react-router'
import { snapshotToArray } from '../../selectors'
import Icon from '@material-ui/core/Icon';
import NProgress from "nprogress";
import { withSnackbar } from 'notistack';
import Button from '../../components/Button'
import { setLocalStorageTitle } from '../../functions/snippets'
import firebase from 'firebase/app';




class Lists extends Component {

    state = {
        lists: JSON.parse(localStorage.getItem('lists')),
        openTab: 2,
        valueSearchList: '',
        user: null
    }

    componentDidMount(){
        //this.setState({
          //  lists: JSON.parse(localStorage.getItem('lists'))
        //})

        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    user
                })
                this.setTab(1)
            } else {
                this.setTab(2)
            }
        });

    }

    componentWillReceiveProps(nextProps) {
        const title  = this.props.title
        const nextTitle  = nextProps.title
        const { id } = nextProps.ownProps.params

        console.log(title, nextTitle)

        if (title !== nextTitle) {
            setLocalStorageTitle(id, nextTitle)
            this.setState({
                lists: JSON.parse(localStorage.getItem('lists')),
            })
        }
    }


    removeListHistory = (key) => {
        let lists = {...this.state.lists};
        delete lists[key];

        this.setState({
            lists
        })

       localStorage.setItem('lists',  JSON.stringify(lists))
    }

    handleRemoveAuthUseList = (id) => {
        const { user, enqueueSnackbar } = this.props
        NProgress.start()
        removeAuthUseList(user.id, id).then(() => {
            enqueueSnackbar('Лист удален');
            NProgress.done()
            this.setState({
                isSavedList: false
            })
        })
    }

    setTab = (i) => {
        this.setState({
            openTab: i
        })
    }

    handleAddList = () => {
        this.props.addList()
        this.props.toggleDropBox(TOGGLE_SETTING_SUCCESS)
    }

    handleSearchList = e => {
        const text = e.target.value;

        this.setState({
            valueSearchList: text
        })

    }

    getLists = () => {
        const lists = snapshotToArray(this.state.lists).filter(list => list.title)
        if(!this.state.valueSearchList.trim().length) return lists
        let searchLists = lists.filter(list => {
            if(list.title.trim().toLowerCase().indexOf(this.state.valueSearchList.trim().toLowerCase()) + 1){
                return true
            }
        })

        return searchLists
    }

    getSavedLists = () => {
        const { savedLists } = this.props;
        if(!this.state.valueSearchList.trim().length) return savedLists
        let searchLists = savedLists.filter(list => {
            if(list.title.trim().toLowerCase().indexOf(this.state.valueSearchList.trim().toLowerCase()) + 1){
                return true
            }
        })

        return searchLists
    }

    render() {
        const { dropBox, toggleDropBox, savedListsNotification } = this.props;
        const listKey = this.props.ownProps.params.id
        const dropClass = classNames({
            'comment': true,
            'active': dropBox.lists,
            'comment__main-page':!listKey
        });

        const lists = this.getLists();
        const savedLists = this.getSavedLists()

        console.log(savedLists)
        //console.log(lists)



        return (
            <div className={dropClass}>
                <div className="comment__wrap">
                    <div className="comment__header">
                        <div className="comment__header-btn">

                        </div>
                        <div className='user-list-nav'>
                            {
                                this.state.user && (
                                    <div onClick={() => this.setTab(1)} className={`comment__title ${this.state.openTab === 1 && 'active'}`}>
                                        Saved lists
                                    </div>
                                )
                            }

                            <div  onClick={() => this.setTab(2)} className={`comment__title ${this.state.openTab === 2 && 'active'}`}>
                                Last lists
                            </div>
                        </div>
                        <div className="comment__close" onClick={() => toggleDropBox(TOGGLE_LISTS_SUCCESS)}>
                            <Icon>arrow_right_alt</Icon>
                        </div>

                        <div className="search-list">
                            <div className="search-list__wrap">
                                <input ref={input => this.input = input} onChange={this.handleSearchList} className='search-list__input' placeholder='Search list' type="text"/>
                                <span className='search-list__btn color_blue'>
                                    <Icon>search</Icon>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="comment__content">
                        <div className={`history ${this.state.openTab === 1 && 'd_n'}`} >
                            {
                                lists &&  lists.map((list, key) => {
                                    return (
                                        <div className='history__element' key={key}>
                                           {/* <Link  to={"/list/" + list.key } > {list.title} </Link>*/}
                                            <a  href={"/list/" + list.key } > {list.title} </a>
                                            <span className='history__delete-list' onClick={() => this.removeListHistory(list.key)}>
                                                <i className="icon-close"></i>
                                            </span>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div className={`history ${this.state.openTab === 2 && 'd_n'}`} >
                            {
                                savedLists && savedLists.map((list, key) => {
                                    let count = 0;
                                    if(savedListsNotification[list.id]){
                                        count =  savedListsNotification[list.id].countHistory
                                    }

                                    return (
                                        <div className='history__element' key={key}>
                                            <a  href={"/list/" + list.id } > {list.title}

                                                {
                                                    count > 0 && <span className='history__notification'> +{count}</span>
                                                }


                                            </a>
                                            <span className='history__delete-list' onClick={() => this.handleRemoveAuthUseList(list.id)}>
                                                <i className="icon-close"></i>
                                            </span>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div className="add-list">
                            <Button title={false} fn={this.handleAddList} icon='icon-plus' type='big' bg='btn_white' />
                        </div>
                    </div>

                 </div>

             </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    dropBox: state.dropBox,
    savedLists: state.savedLists,
    savedListsNotification: state.savedListsNotification,
    user: state.user,
    title: state.title,
    ownProps
})

const mapDispatchToProps = {
    toggleDropBox,
    addList,
    toggleDropBox
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(withSnackbar(Lists))


// WEBPACK FOOTER //
// ./src/containers/drop/Lists.js